import axios from 'axios'
import baseService from './baseService'

const appService = {
  createInvoice (squareInvoice) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/createinvoice', squareInvoice, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getLocations (dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/getlocations?dealerId=' + dealerId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getInvoice (sqInvoiceId, dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/getinvoice?dealerId=' + dealerId + '&invoiceId=' + sqInvoiceId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  updateInvoice (squareInvoice) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/updateinvoice', squareInvoice, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getOrder (sqOrderId, dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/getorder?dealerId=' + dealerId + '&orderId=' + sqOrderId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getCatalogs (dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/getcatalogs?dealerId=' + dealerId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  refundInvoice (refundInvoice) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/refundinvoice', refundInvoice, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  refundNonStandard (refund) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/refundnonstandard', refund, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  refreshSquareRefundStatus (paymentTrackingId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/refreshsquarerefundstatus?depositId=' + paymentTrackingId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getDownloadInvoiceUrl (url, dealerId) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve()
      } else {
        axios({
          url: process.env.VUE_APP_ROOT_DOC_SITE + 'docs/getinvoicedownloadurl?url=' + url + '&dealerId=' + dealerId,
          method: 'GET',
          responseType: 'json',
          data: '',
          withCredentials: false
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response)
        })
      }
    })
  },
  getDeviceCodesByDealerId (dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/getdevicecodesbydealerid?id=' + dealerId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  addDevice (squareDeviceCodeModel) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/adddevice', squareDeviceCodeModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  editDevice (squareDeviceCodeModel) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/editdevice', squareDeviceCodeModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  findPairedDeviceCodesByDealerId (dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/findpaireddevicecodesbydealerid?id=' + dealerId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  findPairedDeviceCodesByDealerIdAndUser (dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/findpaireddevicecodesbydealeridanduser?id=' + dealerId, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  terminalCheckOut (sqTerminalCheckoutModel) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/terminalcheckout', sqTerminalCheckoutModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  signatureTerminalAction (sqTerminalCheckoutModel) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/signatureterminalaction', sqTerminalCheckoutModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  deleteDeviceCode (id) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/deletedevicecode?id=' + id, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getDeviceInfo (id, dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .get('/square/getdevice?dealerId=' + dealerId + '&id=' + id, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response)
          })
      }
    })
  },
  cancelTerminalRequest (sqTerminalCheckoutModel) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/cancelterminalrequest', sqTerminalCheckoutModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  dismissTerminalRequest (sqTerminalCheckoutModel) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios
          .post('/square/dismissterminalrequest', sqTerminalCheckoutModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  }
}

export default appService
